import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Cookies from 'vue-cookies'
import Config from '@/config/app'

import messages from '@/messages'

Vue.use(VueI18n)

// Determine initial locale based on browser language or cookie
function getInitialLocale() {
  // Check if user has previously selected a language (cookie exists)
  if (Cookies.isKey(Config.COOKIES.LANGUAGE_KEY)) {
    const savedLanguage = Cookies.get(Config.COOKIES.LANGUAGE_KEY)
    return savedLanguage.value || 'en'
  }
  
  // For new users, detect browser language
  const browserLanguage = window.navigator.language
  return browserLanguage === 'ja' || browserLanguage.startsWith('ja-') ? 'ja' : 'en'
}

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: getInitialLocale(), // set locale based on browser detection or saved preference
  messages // set locale messages
})

export default i18n
